import React from "react";
import {
  Box, Container, Typography, Grid, Button
} from "@mui/material";
import GalleryGrid from "../components/GalleryGrid";

const galleryImages = [
  "https://ik.imagekit.io/jo6akqndg/Catering/Screenshot%202025-07-30%20at%2011.29.35%E2%80%AFPM.png?updatedAt=1753898472505",
  "https://ik.imagekit.io/jo6akqndg/Catering/Screenshot%202025-07-30%20at%2011.29.51%E2%80%AFPM.png?updatedAt=1753898472460",
  "https://ik.imagekit.io/jo6akqndg/Catering/Screenshot%202025-07-30%20at%2011.29.17%E2%80%AFPM.png?updatedAt=1753898472581",
  "https://ik.imagekit.io/jo6akqndg/Catering/Screenshot%202025-07-30%20at%2011.29.45%E2%80%AFPM.png?updatedAt=1753898476676",
  "https://ik.imagekit.io/jo6akqndg/Catering/Screenshot%202025-07-30%20at%2011.36.59%E2%80%AFPM.png?updatedAt=1753898837408", 
//   "https://ik.imagekit.io/jo6akqndg/Catering/Screenshot%202025-07-30%20at%2011.30.29%E2%80%AFPM.png?updatedAt=1753898476929"
];

const Catering = () => {
  return (
    <Box sx={{ bgcolor: "#FFF8E1", py: 6 }}>
      <Container maxWidth="lg">
        {/* Hero Section */}
        <Box
          component="img"
          src="https://ik.imagekit.io/jo6akqndg/Catering/Screenshot%202025-07-30%20at%2011.29.24%E2%80%AFPM.png?updatedAt=1753898472502"
          alt="Kulche Shulche Catering"
          sx={{
            width: "100%",
            maxHeight: 500,
            objectFit: "cover",
            borderRadius: 3,
            mb: 4,
          }}
        />

        {/* Overview */}
        <Typography
          variant="h4"
          align="center"
          fontWeight="bold"
          gutterBottom
          color="#D35400"
        >
          Catering Services
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph align="center">
          Whether it's corporate events, family gatherings, weddings, or private parties — we bring the authentic taste of Punjabi street food delivered with quality, hygiene, and passion.
        </Typography>

        <Box textAlign="center" mb={4}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            href="/contact"
          >
            Request a Quote
          </Button>
        </Box>

        {/* Gallery */}
        <Box mt={6}>
          <Typography
            variant="h4"
            fontWeight="bold"
            textAlign="center"
            gutterBottom
          >
            Events Gallery
          </Typography>
          <GalleryGrid images={galleryImages} />
        </Box>

        {/* Contact Section */}
        <Box mt={6} sx={{ textAlign: "center" }}>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Book Our Catering Services
          </Typography>
          <Typography variant="body1" gutterBottom>
            For bespoke catering packages, menu customization, or pricing —
          </Typography>
          <Button variant="outlined" color="secondary" href="/contact">
            Contact Us
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Catering;
